import React, { FC } from 'react';
import { Span } from '../../components/Text/Text';
import { LangE } from '../../models/enums';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentLang } from '../../store/selectors/appSelectors';

type BrandNamePropTypes = {
    campaign: any;
    langPostfix?: 'EN' | 'En';
}

const NA = /(N\/A\s\-\s|N\/A)/gm;

const BrandName: FC<BrandNamePropTypes> = (props) => {
    const { campaign, langPostfix = 'EN' } = props;
    const lang = useAppSelector(selectCurrentLang);
    const fieldNameWithLang = `BrandName${langPostfix}`;

    const brandEn = campaign?.[fieldNameWithLang] ? campaign?.[fieldNameWithLang] : campaign?.BrandName;
    const brandHe = campaign?.BrandName;
    const brandEnWithoutNA = brandEn?.replace(NA, '');
    const brandHeWithoutNA = brandHe?.replace(NA, '');
    const title = campaign?.BrandNameToolTip;

    return lang === LangE.EN ? (
        <>
            <span><Span title={title}>Brand</Span>:&nbsp;</span>
            <span title={title}>{brandEnWithoutNA} {
                (brandHeWithoutNA && (brandEnWithoutNA !== brandHeWithoutNA))
                    ? ((brandEnWithoutNA ? ' - ' : '') + brandHeWithoutNA)
                    : ''
            }</span>
        </>
    ) : (
        <>
            <span><Span title={title}>Brand</Span>:&nbsp;</span>
            <span title={title}>{brandHeWithoutNA || brandEnWithoutNA}</span>
        </>
    );
};

export default BrandName;